import { SessionInfo } from 'auth/types';
import { useContext } from 'react';
import SessionInfoContext from './SessionInfoContext';

const useSessionInfo = (): SessionInfo => {
  return useContext(SessionInfoContext);
};

export default useSessionInfo;
